'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Store = exports.Field = exports.Form = undefined;

var _form = require('./form');

var _form2 = _interopRequireDefault(_form);

var _field = require('./field');

var _field2 = _interopRequireDefault(_field);

var _store = require('./store');

var _store2 = _interopRequireDefault(_store);

var _validators = require('./validators');

var _validators2 = _interopRequireDefault(_validators);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable */
(0, _validators2.default)();

var _default = {
	Form: _form2.default,
	Field: _field2.default,
	Store: _store2.default
};
exports.default = _default;
exports.Form = _form2.default;
exports.Field = _field2.default;
exports.Store = _store2.default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/index.js');
}();

;


// WEBPACK FOOTER //
// /Users/david/Source/react-formality/lib/index.js